export default {
  investmentSelectionSectionLabel: 'Veuillez sélectionner des investissements :',
  taxationProductSelectionLabel: "Je souhaite être recontacté sur l'offre",

  taxationProductDescriptionMalraux: 'Acquisition d\'un bien de caractère à restaurer situé dans un Site Patrimonial Remarquable (secteur sauvegardé ou ZPPAUP).',
  taxationProductDescriptionMonumentsHistoriques: 'Acquisition d\'un immeuble classé Monument Historique ou inscrit ISMH (Inventaire Supplémentaire des Monuments Historiques).',
  taxationProductDescriptionDeficitFoncier: 'Acquisition d\'un bien ancien, de caractère, à rénover.',
  taxationProductDescriptionLMNP: 'Investissement dans une résidence avec services conçus spécifiquement pour l\'activité qui y sera exercée (étudiante, séniors, ehpad...).'
}
